import { render, staticRenderFns } from "./JobLogs.vue?vue&type=template&id=f8d60d2c&"
import script from "./JobLogs.vue?vue&type=script&lang=js&"
export * from "./JobLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports